var map = {
	el: {
		container: $('.js-map'),
		locators: $('svg g'),
		modalContainer: $('.map__modal'),
		links: $('.js-map li')
	},

	activateModal: function () {
		var self = this;
		//this.showModal('[data-initials]');
		this.el.container.on('click', 'li', function () {
			var element = $(this);

			self.el.container.find('li').each(function () {
				$(this).removeClass('active');
			})
			self.el.modalContainer.removeClass('show');
			$(this).addClass('active').siblings().removeClass('active');
			setTimeout(function () {
				self.el.modalContainer.addClass('show');

				//change modal content
				self.el.modalContainer.find('.js-map-location').html(element.data('location'))
				self.el.modalContainer.find('.js-map-location').text().length === 0 ? self.el.modalContainer.find('.js-map-location').remove() : ''
				self.el.modalContainer.find('.js-map-address').html(element.data('address'))
				self.el.modalContainer.find('.js-map-address').text().length === 0 ? self.el.modalContainer.find('.js-map-address').remove() : ''
				self.el.modalContainer.find('.js-map-tel').html(element.data('tel'))
				self.el.modalContainer.find('.js-map-tel').text().length === 0 ? self.el.modalContainer.find('.js-map-tel').remove() : ''
				self.el.modalContainer.find('.js-map-email').html(element.data('email'))
				self.el.modalContainer.find('.js-map-email').text().length === 0 ? self.el.modalContainer.find('.js-map-email').remove() : ''
				if (element.data('email-secondary')) {
					self.el.modalContainer.find('.js-map-email-secondary').show();
					self.el.modalContainer.find('.js-map-email-secondary').html(element.data('email-secondary'));
				} else {
					self.el.modalContainer.find('.js-map-email-secondary').hide();
				}
			}, 300);

			self.el.locators.each(function () {
				if (element.data('initials') === $(this).data('initials')) {
					$(this).find('path').css('fill', '#FF6A00');
					$(this).siblings().find('path').css('fill', '#555559')
				}
			})

		})

		this.el.locators.on('click', function () {
			var marker = $(this);

			self.el.links.each(function () {
				if (marker.data('initials') === $(this).data('initials')) {

					marker.find('path').css('fill', '#FF6A00');
					marker.siblings().find('path').css('fill', '#555559')
					self.el.container.find('li').each(function () {
						$(this).removeClass('active');
					})
					self.el.modalContainer.removeClass('show');
					$(this).addClass('active').siblings().removeClass('active');
					setTimeout(function () {
						self.el.modalContainer.addClass('show');

						//change modal content
						self.el.modalContainer.find('.js-map-location').html(marker.data('location'))
						self.el.modalContainer.find('.js-map-location').text().length === 0 ? self.el.modalContainer.find('.js-map-location').remove() : ''
						self.el.modalContainer.find('.js-map-address').html(marker.data('address'))
						self.el.modalContainer.find('.js-map-address').text().length === 0 ? self.el.modalContainer.find('.js-map-address').remove() : ''
						self.el.modalContainer.find('.js-map-tel').html(marker.data('tel'))
						self.el.modalContainer.find('.js-map-tel').text().length === 0 ? self.el.modalContainer.find('.js-map-tel').remove() : ''
						self.el.modalContainer.find('.js-map-email').html(marker.data('email'))
						self.el.modalContainer.find('.js-map-email').text().length === 0 ? self.el.modalContainer.find('.js-map-email').remove() : ''
						if (marker.data('email-secondary')) {
							self.el.modalContainer.find('.js-map-email-secondary').show();
							self.el.modalContainer.find('.js-map-email-secondary').html(marker.data('email-secondary')).attr('href', marker.data('email-secondary'));
						}
					}, 300);
				}
			})
		})
	},

	closeModal: function () {
		var self = this;
		this.el.modalContainer.find('.btn--close').on('click', function () {

			self.el.modalContainer.removeClass('show');
			self.el.modalContainer.find('.js-map-email-secondary').hide();
			self.el.container.find('li').each(function () {
				$(this).removeClass('active');
			})
			self.el.locators.find('path').css('fill', '#555559');
		})
	},

	init: function () {
		this.activateModal();
		this.closeModal();
	}
}

map.init();